export type StorageKey = string;

type Storage = typeof window.localStorage | typeof window.sessionStorage;

class StorageClient {
    storage: Storage;

    constructor(storage: Storage) {
        this.storage = storage;
    }

    saveDataToStorage = (key: StorageKey, data: any) => {
        this.storage.setItem(key, JSON.stringify(data));
    };

    getDataFromStorage = (key: StorageKey) => {
        const data = this.storage.getItem(key);

        if (!data) {
            return null;
        }

        return JSON.parse(data);
    };

    clearStorage = () => this.storage.clear();
}

export const FILTER_KEY = 'survey-list-filter';
export const SCREENING_HINT_KEY = 'screening-hint';

export const localStorageClient = new StorageClient(localStorage);
export const sessionStorageClient = new StorageClient(sessionStorage);
